import { Smartphone } from "lucide-react";
import { RichText } from "@/components/RichText";

const SIZES = [12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 40, 48];

export const MobileSizeControl = ({ value, onChange, testId }) => (
  <label className="flex items-center gap-1.5 text-xs text-muted-foreground" title="Text size used on phones (screens under 640px wide)">
    <Smartphone className="w-3.5 h-3.5" /> Phone size
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      className="h-8 rounded-md border border-input bg-background px-2 text-xs text-foreground"
      data-testid={testId}
    >
      <option value="">Auto</option>
      {SIZES.map((s) => <option key={s} value={s}>{s}px</option>)}
    </select>
  </label>
);

export const MobilePreview = ({ html, size, testId }) => (
  <div className="flex items-start gap-3" data-testid={testId}>
    <div className="w-[300px] max-w-full rounded-2xl border-4 border-slate-800 bg-white px-3 py-4 shadow-sm">
      <p className="text-[10px] uppercase tracking-wide text-slate-400 mb-1">Phone preview</p>
      <RichText html={html} className="m-fs-preview text-slate-700 break-words" style={{ "--m-fs": `${size}px` }} />
    </div>
  </div>
);
